module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/ogp-8de1d350717f683c353c00e32cc733d4.webp";